import React from 'react';
import { ClinicalTrialUpdateType } from '@dynamika-shared/types/clinicalTrials';
import { ControlPropertiesType } from '../uiControlSchemaByStatus/ControlTypes';
import { FieldErrors, UseFormWatch } from 'react-hook-form';
import { renderDatePickerEnd, renderDatePickerStart } from './renderFunctions';
import { d7Format } from '@dynamika-shared/utils/date';

type DateTypeKey =
  | 'startDate'
  | 'endDate'
  | 'firstPatientVisit'
  | 'lastPatientVisit';
type DateRangePickerProps = {
  uiControlSchema: Record<keyof ClinicalTrialUpdateType, ControlPropertiesType>;
  dateClassName: string;
  watch: UseFormWatch<ClinicalTrialUpdateType>;
  onChangeField: (
    fieldName: keyof ClinicalTrialUpdateType,
    value: string | number | undefined
  ) => void;
  startDateKey: DateTypeKey;
  endDateKey: DateTypeKey;
  errors: FieldErrors<ClinicalTrialUpdateType>;
  renderDatePickerStart: typeof renderDatePickerStart;
  renderDatePickerEnd: typeof renderDatePickerEnd;
  disabled?: boolean;
};

const DateRangePicker: React.FC<DateRangePickerProps> = ({
  uiControlSchema,
  dateClassName,
  watch,
  onChangeField,
  startDateKey,
  endDateKey,
  errors,
  renderDatePickerStart,
  renderDatePickerEnd,
  disabled
}) => {
  return (
    <div className={'mt-1.5 flex w-full justify-end gap-6.5'}>
      {uiControlSchema[startDateKey].asText ? (
        <div className={dateClassName}>
          {watch(startDateKey) &&
            d7Format(watch(startDateKey), 'dd-MMM-yyyy')}
        </div>
      ) : (
        renderDatePickerStart({
          watch,
          onChangeField,
          startDate: startDateKey,
          endDate: endDateKey,
          errors,
          disabled
        })
      )}

      {uiControlSchema[endDateKey].asText ? (
        <div className={dateClassName}>
          {watch(endDateKey) &&
            d7Format(watch(endDateKey), 'dd-MMM-yyyy')}
        </div>
      ) : (
        renderDatePickerEnd({
          watch,
          onChangeField,
          startDate: startDateKey,
          endDate: endDateKey,
          errors,
          disabled
        })
      )}
    </div>
  );
};

export default DateRangePicker;
